<template>
  <router-view />
</template>

<script>
export default {
    name: "UserLayout",
};
</script>
